export default __webpack_public_path__ + "static/media/gl-4.de6ed7d7.png";